export interface PriceGroupServerItem {
  id: string;
  store_id: string;
  name: string;
  value: string | number;
  is_active: boolean;
  created_at?: string | null;
  updated_at?: string | null;
  item_count: number;
}

export interface PriceGroupsServerData {
  store_id: string;
  items: PriceGroupServerItem[];
}

export interface PriceGroupRow {
  id: string;
  name: string;
  price: string;
  itemCount: string;
  status: string;
}

class PriceGroupModel {
  private _serverData: PriceGroupServerItem;

  constructor(serverData: PriceGroupServerItem) {
    this._serverData = serverData;
  }

  get id() {
    return this._serverData.id ?? '';
  }

  get name() {
    return this._serverData.name ?? '';
  }

  get value() {
    return this._serverData.value ?? '';
  }

  get is_active() {
    return Boolean(this._serverData.is_active);
  }

  get item_count() {
    return Number(this._serverData.item_count ?? 0);
  }

  toRowFormat(): PriceGroupRow {
    return {
      id: this.id || `${this.name}-${this.value}`,
      name: this.name || '-',
      price: Number(this.value ?? 0).toFixed(2),
      itemCount: String(this.item_count),
      status: this.is_active ? 'Active' : 'Inactive',
    };
  }

  getRawData() {
    return this._serverData;
  }

  static fromServerData(serverData: PriceGroupServerItem) {
    return new PriceGroupModel(serverData);
  }
}

class PriceGroupsListModel {
  private _storeId: string;
  private _items: PriceGroupModel[];

  constructor(serverData: PriceGroupsServerData | null = null) {
    this._storeId = String(serverData?.store_id ?? '').trim();
    this._items = Array.isArray(serverData?.items)
      ? (serverData?.items || []).map((item) => PriceGroupModel.fromServerData(item))
      : [];
  }

  get storeId() {
    return this._storeId;
  }

  get items() {
    return this._items;
  }

  toRowFormat() {
    return this._items.map((item) => item.toRowFormat());
  }

  getRawData() {
    return this._items.map((item) => item.getRawData());
  }

  static fromServerData(serverData: PriceGroupsServerData | null | undefined) {
    return new PriceGroupsListModel(serverData ?? null);
  }

  static createEmpty() {
    return new PriceGroupsListModel(null);
  }
}

export default PriceGroupsListModel;
export { PriceGroupModel };
